import React from "react";
import { useNavigate } from "react-router-dom";
import "./JoinUs.css";

const JoinUs = () => {
  const navigate = useNavigate();
  const nicoLucas = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/nico-lucas.jpeg";

  const handleJoinClick = () => {
    navigate("/contact");
  };

  return (
    <section className="join-us-section">
      <h2 className="join-title">Join Us</h2>
      <div className="join-content">
        <div className="join-text">
          <p>
            You can register for a session by contacting us through our website or by calling us directly.
            <br />
            <br />
            We will provide you with all the necessary information and help you get started.
            <br />
            <br />
            No prior experience is necessary to join our beginner training sessions. 
            Our coaches will help you build a strong foundation in minifootball.
          </p>
        </div>
        <div className="join-image-container">
          <img src={nicoLucas} alt="Coach Nico Lucas" className="join-image" />
          <button className="join-button" onClick={handleJoinClick}>
            Join Our Team
          </button>
        </div>
      </div>
    </section>
  );
};

export default JoinUs;
